import styled from '@emotion/styled'
import { FunctionComponent } from 'react'
import { Flyout } from '~/components/Flyout'

const SectionTitle = styled.h2`
  padding: 1.5rem 0 0.75rem 0;
`

export const AdUnitsHelpFlyout: FunctionComponent = () => {
  return (
    <Flyout.Content>
      <Flyout.Title>Help</Flyout.Title>
      <Flyout.Body>
        <SectionTitle>How do you connect ad units to the server-side header bidding system?</SectionTitle>
        <p>1. Click on “Add ad units”.</p>
        <p>2. Define the ad unit name.</p>
        <SectionTitle>Why should I add the ad units to the inventory?</SectionTitle>
        <p>In order to monetise ad units successfully, they must be declared and mapped with bidders.</p>
      </Flyout.Body>
    </Flyout.Content>
  )
}
